<template>
  <div class="test-result">
    <HeadedContainer padded>

      <template v-slot:header>
        {{ $ml.get(`WATER TEST RESULT`) }}
      </template>

      <div class="body" v-if="loaded">

        <!-- <div class="head">
          <div class="col">Nutrient</div>
          <div class="col">Unit</div>
          <div class="col">Test result</div>
        </div> -->

        <DropList bordered opened>
          <template v-slot:header>
            {{ $ml.get(`N-Forms`) }}
          </template>

          <TestResultNutrientItem
            v-for="item in nForms"
            :item="item"
          />

        </DropList>

        <DropList bordered opened>
          <template v-slot:header>
            {{ $ml.get(`Nutrients`) }}
          </template>

          <TestResultNutrientItem
            v-for="item in microNutrients"
            :item="item"
          />

        </DropList>
      </div>
    </HeadedContainer>
  </div>
</template>

<script>
import HeadedContainer from '@/components/common/HeadedContainer'
import DropList from '@/components/common/DropList'
import TestResultNutrientItem from '@/components/tests/water/TestResultNutrientItem'

export default {
  components: {
    HeadedContainer,
    DropList,
    TestResultNutrientItem,
  },
  data() {
    return {

    }
  },
  computed: {
    data() {
      return this.$store.getters['tests/water/form'].data;
    },
    loaded() {
      return this.data.length;
    },
    nForms() {
      return this.data.filter(el => el.n_form && el.key != 'NNH2')
    },
    microNutrients() {
      return this.data.filter(el => !el.n_form && el.key != 'Al')
    },
  },
}
</script>

<style lang="scss" scoped>

.test-result {
  // .head {

  //   display: flex;
  //   flex-direction: row;
  //   align-items: center;
  //   justify-content: space-between;

  //   .col {
  //     width: 33.3%;
  //     flex-grow: 1;
  //     color: #4C5056;
  //     font-weight: bold;
  //     text-transform: uppercase;
  //     padding-bottom: 15px;

  //     display: flex;
  //     flex-direction: row;
  //     align-items: center;
  //     justify-content: space-between;
  //   }
  // }
  .body {
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }
}

</style>
